import React, { useState } from "react";
import SyntaxHighlighter from "react-syntax-highlighter/dist/esm/default-highlight";
import xmlFormat from 'xml-formatter';
import { theme, Button, message } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

import {
  atomOneLight,
  atomOneDark,
} from "react-syntax-highlighter/dist/esm/styles/hljs";

const { useToken } = theme;

export const CodeBlock = (props: { children?: string; language: string }) => {
  const { token } = useToken();
  const [copied, setCopied] = useState(false);

  const isDarkTheme = token.colorBgBase === "#000";

  const handleCopy = async () => {
    if (props.children) {
      try {
        await navigator.clipboard.writeText(props.children);
        setCopied(true);
        message.success("Code copied to clipboard!");
        setTimeout(() => setCopied(false), 2000);
      } catch (error) {
        message.error("Failed to copy code");
      }
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Button
        type="text"
        icon={copied ? <CheckOutlined /> : <CopyOutlined />}
        onClick={handleCopy}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 10,
          color: isDarkTheme ? "#fff" : "#000",
        }}
      />
      {/* Corrected 2026-09-18 (KI-11): this used to hardcode the "1c" hljs grammar here,
          ignoring props.language entirely. `default-highlight` ships the full hljs bundle
          with every grammar pre-registered, so the prop can be passed straight through
          with no registerLanguage wiring. */}
      <SyntaxHighlighter
        style={isDarkTheme ? atomOneDark : atomOneLight}
        language={props.language}
      >
        {props.language === "xml" && props.children ? xmlFormat(props.children) : props.children}
      </SyntaxHighlighter>
    </div>
  );
};
